import { render, staticRenderFns } from "./memberStoredRecordList.vue?vue&type=template&id=2fcae612"
import script from "./memberStoredRecordList.vue?vue&type=script&lang=js"
export * from "./memberStoredRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports